import React from 'react'

const TransferOrdersMob = () => {
  return (
    <div>TransferOrdersMob</div>
  )
}

export default TransferOrdersMob